<template>
  <div class="fc-alert">
    <div class="fc-alert__container">
      <h1 class="fc-alert__title" v-if="title">
        <template v-for="(v, index) in stringParser(title)"> {{ v }}<br :key="index" /> </template>
      </h1>
      <div class="fc-alert__subtitle" v-if="subtitle">
        <template v-for="(v, index) in stringParser(subtitle)"> {{ v }}<br :key="index" /> </template>
      </div>
      <div class="fc-alert__image" v-if="imageUrl">
        <img :src="imageUrl" :alt="subtitle" />
      </div>
      <div class="fc-alert__button" v-if="buttonText">
        <button @click="confirm" class="btn-confirm">
          <i :class="`icon icon--${buttonIcon}`" />
          <span class="btn-confirm__text">{{ buttonText }}</span>
        </button>
      </div>
    </div>
    <div class="fc-alert__footer">
      <div class="fc-today">
        <input id="close-alert" type="checkbox" v-model="isClosedToday" @change="updateTodayCookie" />
        <label for="close-alert">오늘 하루 보지 않기</label>
      </div>
      <button @click="close" class="btn-close"></button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'alert',
  props: ['run', 'title', 'subtitle', 'slug', 'imageUrl', 'buttonText', 'buttonIcon', 'env'],
  data() {
    return {
      isClosedToday: false,
    };
  },
  methods: {
    stringParser(s) {
      return s.split('\n');
    },
    setCookieAt00(key, value, days) {
      let localKey = this.slug || key;
      let now = new Date();
      let expireDays = new Date();

      if (days) {
        // dev, QA(staging)은 오늘 하루 팝업 10분설정
        if (this.env === 'prod' || this.env === 'staging') {
          expireDays.setDate(now.getDate() + days);
          expireDays.setMinutes(0);
          expireDays.setHours(0);
          expireDays.setMinutes(0);
          expireDays.setSeconds(0);
          expireDays.setMilliseconds(0);
        } else {
          expireDays.setMinutes(expireDays.getMinutes() + 10);
        }
      }

      expireDays = `; expires=${expireDays.toUTCString()}`;
      document.cookie = `${localKey}=${value}${expireDays}; path=/${this.slug}; domain=fastcampus.co.kr`;

      if (this.env !== 'prod') {
        console.log(
          `${localKey}=${value}${expireDays}; path=/${this.slug}; domain=fastcampus.co.kr`,
          `this.env${this.env}`
        );
      }
    },
    updateTodayCookie() {
      this.setCookieAt00('fc_promotion_popup', 'checked', this.isClosedToday ? 1 : 0);
    },
    confirm() {
      this.close();
      this.$emit('callback');
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@fastcampus/styles/style.scss';

.fc-alert {
  margin: 0 2rem;

  &__container {
    padding: 3.2rem 2.4rem;
    border-radius: 0.4rem;

    background-color: #fff;
  }

  &__image {
    position: relative;
    overflow: hidden;

    width: 100%;
    max-width: 40rem;
    height: 100%;
    max-height: 20rem;

    background-color: #f7f7f7;
    img {
      object-fit: cover;

      width: 100%;
      height: 100%;
    }
  }

  &__subtitle {
    @include ellipsis(2);
    max-width: 25.6rem;
    max-height: 4.7rem;

    font-size: 1.4rem;
    & + .fc-alert__image {
      margin-top: 2.4rem;
    }
  }

  &__title {
    @include ellipsis(2);
    max-width: 25.6rem;
    max-height: 6.5rem;

    font-size: 2rem;
    & + .fc-alert__subtitle {
      margin-top: 0.8rem;
    }
  }

  &__button {
    width: 100%;
  }

  &__footer {
    display: flex;
    align-items: center;
    justify-content: space-between;

    margin-top: 1.2rem;

    font-size: 1.6rem;
    color: #aaaaaf;
  }
  @include mq($until: small) {
    width: 100%;
    max-width: 44.8rem;
    &__image {
      height: 0;
      padding-bottom: 50%;
      img {
        position: absolute;
        top: 50%;
        left: 50%;

        transform: translate(-50%, -50%);
      }
    }
  }
  @include mq($from: small) {
    &__image {
      width: 40rem;
      img {
        max-height: 20rem;
      }
    }
  }
}
.fc-today {
  input[type='checkbox'] {
    display: none;
    & + label {
      position: relative;
      display: inline-block;

      padding-left: 2.8rem;

      cursor: pointer;
      &::before {
        content: ' ';
        position: absolute;
        left: 0;
        display: inline-block;

        box-sizing: border-box;
        width: 2rem;
        height: 2rem;
        border: 0.1rem solid #aaaaaf;
        border-radius: 0.4rem;

        transform: translateY(calc(50% - 0.8rem));
      }
    }
    &:checked {
      & + label {
        &::before {
          border: 0;

          background: #ed234b
            url("data:image/svg+xml,%3Csvg width='14' height='10' viewBox='0 0 14 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 5L5 9L13 1' stroke='white' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A")
            no-repeat center center;
        }
      }
    }
  }
}
.btn-confirm {
  display: flex;
  align-items: center;
  justify-content: center;
  &__text {
    display: inline-block;
    overflow: hidden;

    max-width: 16rem;
    height: 2.2rem;

    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .icon {
    &--download {
      position: relative;
      &::before {
        content: url("data:image/svg+xml,%3Csvg width='18' height='16' viewBox='0 0 18 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 11V15H17V11' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M5 6L9 10L13 6' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M9 10V1' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");
        position: absolute;
        top: -0.8rem;
        left: -3rem;

        width: 2rem;
        height: 1.6rem;
      }
    }
  }
}

.btn-close {
  width: 2rem;
  height: 2rem;

  background: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='2.21973' y='3.63416' width='2' height='20' rx='1' transform='rotate(-45 2.21973 3.63416)' fill='%23AAAAAF'/%3E%3Crect x='16.3618' y='2.21997' width='2' height='20' rx='1' transform='rotate(45 16.3618 2.21997)' fill='%23AAAAAF'/%3E%3C/svg%3E%0A")
    no-repeat;
  &:hover {
    background: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='2.21997' y='3.63416' width='2' height='20' rx='1' transform='rotate(-45 2.21997 3.63416)' fill='white'/%3E%3Crect x='16.3621' y='2.21997' width='2' height='20' rx='1' transform='rotate(45 16.3621 2.21997)' fill='white'/%3E%3C/svg%3E%0A")
      no-repeat;
  }
}
</style>
